import { ArrayUtils } from '@colonist/utils';
import { PlayerTitleEnum } from '@colonist/game-states';
export class PlayerTitleState {
    earnTitle(title) {
        if (this.titles.includes(title)) return;
        this.titles.push(title);
    }
    loseTitle(title) {
        const index = this.titles.indexOf(title);
        if (index == -1) return;
        this.titles.splice(index, 1);
    }
    hasTitle(title) {
        return this.titles.includes(title);
    }
    getFinalTitle() {
        if (this.finalTitle != undefined) return this.finalTitle;
        if (this.titles.length == 0) return undefined;
        const highestPriorityTitles = this.getTitlesWithHighestPriority();
        this.finalTitle = ArrayUtils.randomElementFromArray(highestPriorityTitles);
        return this.finalTitle;
    }
    getTitlesWithHighestPriority() {
        if (this.titles.length === 0) return [];
        const titlePriorities = this.titles.map((title)=>({
                title: title,
                priority: PlayerTitleState.getTitlePriority(title)
            }));
        const highestPriority = Math.min(...titlePriorities.map((titlePriority)=>titlePriority.priority));
        const highestPriorityTitles = titlePriorities.filter((titlePriority)=>titlePriority.priority == highestPriority);
        return highestPriorityTitles.map((titlePriority)=>titlePriority.title);
    }
    static getTitlePriority(title) {
        switch(title){
            case PlayerTitleEnum.Monopolist:
                return 1;
            case PlayerTitleEnum.Juggernaut:
                return 2;
        }
    }
    constructor(){
        this.titles = [];
        this.finalTitle = undefined;
    }
}
